export const TOGGLEFULLSCREEN = 'TOGGLEFULLSCREEN';
export const SETLOGINDISPLAY = 'SETLOGINDISPLAY';
export const SETEXPANDEDMENUITEM = 'SETEXPANDEDMENUITEM';
export const SETLISTFILTERS = 'SETLISTFILTERS';
export const SETFILTERPRESET = 'SETFILTERPRESET';
export const UPDATECONFIG = "UPDATECONFIG";
